import React from 'react';
import styled from '@cthings.co/styled-components';
import { CloseButton } from '@bit/first-scope.close-button';
import { ReactComponent as SearchIcon } from '../../../../../assets/Search.svg';

import { colorFetchFDS as colorFetch } from '@cthings.co/styles-utils';
import { useTheme } from '@cthings.co/styled-components';

const Wrapper = styled.div`
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 14px;
  border-bottom: 1px solid;
  border-color: ${colorFetch('gray3')};
  & > svg > path {
    stroke: ${colorFetch('primary')};
  }
`;

const Input = styled.input`
  width: calc(100% - 36px);
  margin-left: 4px;
  border: none;
  padding: none;
  outline: none;
  font-family: Poppins, sans-serif;
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
  color: ${colorFetch('gray1')};
  ::placeholder {
    font-family: Poppins, sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: ${colorFetch('gray2')};
  }
`;

export const SearchInput = ({
  value,
  handleOnChange,
  handleClearInput,
  languageStrings,
  ...props
}: {
  value: string;
  handleOnChange: (value: string) => void;
  handleClearInput: () => void;
  languageStrings: any;
}) => {
  const theme = useTheme();

  return (
    <Wrapper {...props} theme={theme}>
      <SearchIcon />
      <Input
        value={value}
        // @TODO fix type
        onChange={handleOnChange as any}
        placeholder={languageStrings.searchBarPlaceholder}
      />
      {value && <CloseButton onClick={handleClearInput} width={'16px'} height={'16px'} strokeWidth={'2px'} />}
    </Wrapper>
  );
};
